var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _c(_vm.shownIconComponentName, {
        tag: "component",
        staticClass: "fill-icon-primary",
        class: [_vm.iconClasses, _vm.iconSizeClasses],
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }